import React from 'react';
import { useTranslation } from 'react-i18next';

import AppIcon from '../../../shared/ui/AppIcon';

const PUBLIC_URL =
  process.env.PUBLIC_URL || '';
const HANWHA_LOGO_PATH =
  `${PUBLIC_URL}/Hanwha_logo.png`;

export default function LoginForm({
  form,
  showPassword,
  error,
  isSubmitting,
  onInputChange,
  onSubmit,
  onTogglePassword,
  onFindAccount,
  onSignup,
}) {
  const { t } = useTranslation('login');

  const errorMessage = error?.key
    ? t(error.key, {
      ...error.values,
      defaultValue: t('errors.unknown'),
    })
    : '';

  const userIdHasError = error?.field === 'userId';
  const passwordHasError = error?.field === 'password';

  const userIdErrorId = userIdHasError
    ? 'login-error-message'
    : undefined;

  const passwordErrorId = passwordHasError
    ? 'login-error-message'
    : undefined;

  return (
    <form
      className="login-form"
      onSubmit={onSubmit}
      noValidate
      aria-busy={isSubmitting}
    >
      <button
        type="button"
        className="login-brand-logo-button"
        onClick={() => {
          window.location.reload();
        }}
        aria-label="Reload page"
      >
        <div className="login-brand-logo">
          <img
            src={HANWHA_LOGO_PATH}
            alt={t('brand.platformLabel')}
          />

          <div>
            <strong className="login-brand-title">
              Hanwha Semitech
              <br />
              Hi-Portal
            </strong>
          </div>
        </div>
      </button>
      <div className="form-group">
        <label htmlFor="userId" style={{ marginTop: '10px' }}>
          {t('login.userId.label')}
        </label>
        <input
          id="userId"
          name="userId"
          type="text"
          value={form.userId}
          onChange={onInputChange}
          placeholder={t('login.userId.placeholder')}
          autoComplete="username"
          maxLength={100}
          style={{ height: '40px' }}
          disabled={isSubmitting}
          aria-invalid={userIdHasError}
          aria-describedby={userIdErrorId}
        />
      </div>

      <div className="form-group">
        <label htmlFor="password">
          {t('login.password.label')}
        </label>

        <div className="password-input-wrapper">
          <input
            id="password"
            name="password"
            type={showPassword ? 'text' : 'password'}
            value={form.password}
            onChange={onInputChange}
            placeholder={t('login.password.placeholder')}
            autoComplete="current-password"
            maxLength={128}
            style={{ height: '40px' }}
            disabled={isSubmitting}
            aria-invalid={passwordHasError}
            aria-describedby={passwordErrorId}
          />

          <button
            type="button"
            className="password-toggle-button"
            onClick={onTogglePassword}
            disabled={isSubmitting}
            aria-label={
              showPassword
                ? t('login.password.hide')
                : t('login.password.show')
            }
            aria-pressed={showPassword}
          >
            <AppIcon
              type={showPassword ? 'eyeOff' : 'eye'}
              size={20}
            />
          </button>
        </div>
      </div>

      <div
        className="login-options"
      >
        <label
          className="remember-checkbox"
        >
          <input
            name="rememberId"
            type="checkbox"
            checked={
              form.rememberId
            }
            onChange={
              onInputChange
            }
          />

          <span
            className="custom-checkbox"
          />

          <span>
            {t(
              'login.rememberId',
            )}
          </span>
        </label>

        <div
          className="login-account-actions"
        >
          <button
            type="button"
            className="text-button"
            onClick={
              onFindAccount
            }
          >
            {t(
              'login.findAccount',
            )}
          </button>

          <button
            type="button"
            className="text-button"
            onClick={
              onSignup
            }
          >
            {t(
              'quickMenu.signup.title',
              {
                ns: 'app',
              },
            )}
          </button>
        </div>
      </div>

      {errorMessage && (
        <p
          id="login-error-message"
          className="login-error"
          role="alert"
          aria-live="polite"
        >
          {errorMessage}
        </p>
      )}

      <button
        type="submit"
        className="login-button"
        disabled={isSubmitting}
      >
        <span>
          {isSubmitting
            ? t('login.submitting')
            : t('login.submit')}
        </span>

        {!isSubmitting && (
          <AppIcon type="arrow" size={20} />
        )}
      </button>
    </form>
  );
}